import type { JSX } from 'react';
import { styled } from '@mui/material';
import type { IBiomarkerLine } from '@/types/PatientDashboard/PatientTimeline.types';
import ChartSeriesGlyph from './ChartSeriesGlyph';
import { LaneCheckbox, LaneRow, LaneRowName } from './ChartLane.styles';

const Row = styled(LaneRow)({
  gap: '4px',
  paddingLeft: '8px',
});

const VariantCheckbox = styled(LaneCheckbox)({
  marginRight: '2px',
});

interface IProps {
  line: IBiomarkerLine;
  isSelected: boolean;
  onToggle: (variantId: string) => void;
}

export default function BiomarkerLegendRow({ line, isSelected, onToggle }: IProps): JSX.Element {
  const handleChange = (): void => onToggle(line.variantId);

  return (
    <Row>
      <VariantCheckbox
        checked={isSelected}
        onChange={handleChange}
        disableRipple
        inputProps={{ 'aria-label': `Toggle ${line.label}` }}
      />
      <ChartSeriesGlyph colour={line.colour} />
      <LaneRowName
        truncate
        tooltipText={line.label}
        variant="bodyTiny"
        fontWeight="medium"
      >
        {line.label}
      </LaneRowName>
    </Row>
  );
}
